import React from "react";
import { Route, Redirect } from "react-router-dom";
import authenticationService from '../services/authentication.service';
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : PrivateRoute
Description : Pagina de PrivateRoute para permitir acceso a las paginas si el loguin esta correcto.
Date Autor Modification
================================================================================
2/11/2021 Cristian Andres Pizo Mina - Pagina de PrivateRoute.
================================================================================ */
export function PrivateRoute({ component, ...options }) {

    const autenticado = authenticationService.getAuthUser();

    return (
        autenticado.token && autenticado.type === "APPROVER"
            ? <Route {...options} component={component} />
            : (autenticado.token && autenticado.type === "CLIENT" && (options.location.pathname === "/Certificate" ||
                options.location.pathname === "/Voucher" || options.location.pathname === "/CIRVoucher" || options.location.pathname === "/PasswordManagement"
                || options.location.pathname === "/Support" || options.location.pathname === "/CreatePerson" || options.location.pathname === "/CreateEmployee"
                || options.location.pathname === "/Retefuente" || options.location.pathname === "/Historic" || options.location.pathname === "/Licenses" || options.location.pathname === "/MyTrackingReport"
                || options.location.pathname === "/Historic" || options.location.pathname === "/Home" || options.location.pathname === "/TI" ||
                options.location.pathname === "/Week" || options.location.pathname === "/Documents"
                || options.location.pathname === "/SignDocument" || options.location.pathname === "/DocumentSigning" || options.location.pathname === "/Welcome") ? localStorage.getItem('kiosco') ? <Redirect to="/Kiosco" /> :
                <Route path={options.location.pathname} {...options} component={component} /> : <Redirect to="/Login" />)
    )
};


export default PrivateRoute;
